<app-dialog-header
  [title]="data.edit ? 'ELSID ändern' : 'Einsatz erstellen'"
  (close)="dialogRef.close()"
/>
<div mat-dialog-content>
  <div>
    <p>Einsatznummer (ELSID)</p>
    <kpi4me-text-element
      [customValidatorMessage]="customMissionNumberValidatorErrorMessages"
      (keydown.backspace)="onBackspace($event)"
      [formControlElement]="form.controls.missionNumber"
      [data]="missionNumberData"
      [patternErrorMessage]="'Die Transportnummer muss im Format \<Jahr\>|\<AuftragsNr\> eingegeben werden.'"
    ></kpi4me-text-element>
  </div>
  @if (!data.edit) {
    <div>
      <p>Datum des Einsatzes</p>
      <kpi4me-date-element
        [formControlElement]="form.controls.date"
        [data]="dateData"
        [customValidatorMessage]="customDateValidatorErrorMessages"
      />
    </div>
    <div>
      <p>Zu welchem Geschäftsfeld gehört der Einsatz?</p>
      <kpi4me-select-element
        [formControlElement]="form.controls.businessAreaSignature"
        [data]="selectBusinessAreaData"
      />
    </div>
    <div>
      <p>Zu welcher Rettungswache gehört der Einsatz?</p>
      <kpi4me-select-element
        [formControlElement]="form.controls.ambulanceStationSignature"
        [data]="selectAmbulanceStationData"
      />
    </div>
  }
</div>
<div mat-dialog-actions style="gap: 10px">
  <app-confirm-icon-button
    [disabled]="form.invalid || form.pending"
    (customClick)="dialogRef.close(form.value)"
    style="height: 2rem;"
  />

  <button
    [disabled]="form.invalid || form.pending"
    (click)="onCreateAdditional()"
    mat-raised-button
    color="primary"
    style="height: 2rem;"
  >
    Weiteren Einsatz erstellen
  </button>
</div>
